import { LightningElement } from "lwc";

export default class ComHeader extends LightningElement {}
